import { z } from 'zod';
/**
 * How a contact on the call list ends: submitted as a lead (only the lead
 * endpoint sets this, once the lead is on its way) or closed by the rep
 * because there is no interest.
 */ export const PARTNER_CONTACT_OUTCOMES = [
    'lead',
    'noInterest'
];
export const PartnerContactOutcomeSchema = z.enum(PARTNER_CONTACT_OUTCOMES);
/**
 * A prospect on a partner sales rep's personal call list. Private to the rep
 * who created it — neither colleagues nor the partner admin can read it.
 */ export const PartnerContactSchema = z.object({
    _id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().optional(),
    phone: z.string().optional(),
    company: z.string(),
    note: z.string().optional(),
    /** How the rep closed the contact; absent while it is still open. */ outcome: PartnerContactOutcomeSchema.optional(),
    outcomeAt: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional()
});
const normalized = (value)=>value?.trim().toLowerCase() ?? '';
/**
 * Which contact an imported row is: by email when it has one, else by name
 * and company. An import updates the contact with the same key instead of
 * adding it twice; the frontend preview and the backend import share this
 * one definition so they agree on what counts as the same person.
 */ export function partnerContactImportKey(contact) {
    const email = normalized(contact.email);
    if (email) return `email:${email}`;
    return `name:${[
        contact.firstName,
        contact.lastName,
        contact.company
    ].map(normalized).join('|')}`;
}

//# sourceMappingURL=partner-contact.schema.js.map